(function ($) {
	var Sage = {
		// All pages
		'common': {
			init: function () {
				// Newsletter footer
				$('footer .mc4wp-form-505').find('input[type="submit"]').after('<span class="lnr lnr-envelope"></span>');
				$('footer .mc4wp-form-505').find('.lnr').click(function () {
					$('footer .mc4wp-form-505').submit();
				});
			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function () {
				// Home slider
				var homeVideo = $('.fn-home-video video');

				if (homeVideo.length > 0) {
					var videos = [];
					var vidCounter = 0;
					homeVideo.each(function (index, video) {
						videos.push(video);
					});

					// Wait for all videos to load before showing
					videos.forEach(function (video) {
						if (video.localName === 'video') {
							video.onloadedmetadata = function () {
								vidCounter++;
								if (vidCounter === videos.length) {
									$('.selma-home-slider').addClass('videos-ready');
								}
							};
						} else {
							console.log('this element is not a media type...');
						}
					});
				}

			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'kontakta_oss': {
			init: function () {
				var locationmap = window.locationmap = window.locationmap || {};

				function initMap() {
					var uluru = { lat: 59.8280726, lng: 13.1291363 };
					var map = new google.maps.Map(document.getElementById('map'), {
						zoom: 12,
						center: uluru,
						scrollwheel: false,
						styles: [
							{
								"featureType": "administrative",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#444444"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "all",
								"stylers": [
									{
										"color": "#f2f2f2"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road",
								"elementType": "all",
								"stylers": [
									{
										"saturation": -100
									},
									{
										"lightness": 45
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "simplified"
									}
								]
							},
							{
								"featureType": "road.arterial",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "transit",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "all",
								"stylers": [
									{
										"color": "#8096a8"
									},
									{
										"visibility": "on"
									}
								]
							}
						]
					});
					var marker = new google.maps.Marker({
						position: uluru,
						map: map,
						icon: '/wp-content/themes/selmaspa/assets/images/selma_map_pin.png'
					});
				}

				// Lazy Load Google Maps
				function includeApi() {
					var js;
					var fjs = document.getElementsByTagName('script')[0];

					if (!document.getElementById('gmap-api')) {
						console.log('Initialized Google Maps');
						js = document.createElement('script');
						js.id = 'gmap-api';
						js.setAttribute('async', '');
						js.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyC7GKkuqyjz75qVOb60AjhB8_WTy5v4z_8&callback=locationmap.initMap";
						fjs.parentNode.insertBefore(js, fjs);
					}
				}

				// Check if the map is in viewprot
				$.fn.isInViewport = function () {
					var elementTop = $(this).offset().top;
					var elementBottom = elementTop + $(this).outerHeight();

					var viewportTop = $(window).scrollTop();
					var viewportBottom = viewportTop + $(window).height();

					return elementBottom > viewportTop && elementTop < viewportBottom;
				};

				// This is where we init the map
				if (document.getElementById('map')) {
					locationmap.initMap = initMap;

					// Check if viewport contains the map then include the Maps Api
					$(window).on('resize scroll', function () {
						var elementMap = $('.selma-map');
						if (elementMap.isInViewport()) {
							includeApi();
						}
					});
				} else {
					console.log('no map');
				}
			}
		}
	};

	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
